<cx-spinner class="overlay" *ngIf="isUpdating$ | async"> </cx-spinner>
<!-- TODO: (CXSPA-5953) Remove feature flags next major -->
<p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
  {{ 'formLegend.required' | cxTranslate }}
</p>
<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <label>
    <span class="label-content">{{
      'updateProfileForm.title' | cxTranslate
    }}</span>
    <ng-select
      [clearable]="false"
      [searchable]="false"
      formControlName="titleCode"
      id="title-select"
      [cxNgSelectA11y]="{
        ariaLabel: 'updateProfileForm.title' | cxTranslate,
      }"
    >
      <ng-option *ngFor="let title of titles$ | async" [value]="title.code">{{
        title.name
      }}</ng-option>
    </ng-select>
  </label>
  <label>
    <span class="label-content"
      >{{ 'updateProfileForm.firstName.label' | cxTranslate }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
    ></span>
    <input
      required="true"
      type="text"
      class="form-control"
      name="firstName"
      placeholder="{{
        'updateProfileForm.firstName.placeholder' | cxTranslate
      }}"
      formControlName="firstName"
      [attr.aria-describedby]="'firstNameError'"
    />

    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="firstNameError"
      aria-live="off"
      [translationParams]="{
        label: 'updateProfileForm.firstName.label' | cxTranslate,
      }"
      [control]="form.get('firstName')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('firstName')"
    ></cx-form-errors>
  </label>

  <label>
    <span class="label-content"
      >{{ 'updateProfileForm.lastName.label' | cxTranslate }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
    ></span>
    <input
      required="true"
      type="text"
      class="form-control"
      name="lastName"
      placeholder="{{ 'updateProfileForm.lastName.placeholder' | cxTranslate }}"
      formControlName="lastName"
      [attr.aria-describedby]="'lastNameError'"
    />

    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="lastNameError"
      aria-live="off"
      [translationParams]="{
        label: 'updateProfileForm.lastName.label' | cxTranslate,
      }"
      [control]="form.get('lastName')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('lastName')"
    ></cx-form-errors>
  </label>

  <label>
    <span class="label-content">{{
      'updateProfileForm.customerId' | cxTranslate
    }}</span>
    <input
      required="true"
      type="text"
      class="form-control"
      name="customerId"
      formControlName="customerId"
      [attr.aria-describedby]="'customerIdError'"
      readonly
    />

    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="customerIdError"
      aria-live="off"
      [translationParams]="{
        label: 'updateProfileForm.customerId' | cxTranslate,
      }"
      [control]="form.get('customerId')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('customerId')"
    ></cx-form-errors>
  </label>

  <!-- TODO: (CXSPA-7252) - Remove feature flag next major release -->
  <ng-container *cxFeature="'a11yUseButtonsForBtnLinks'">
    <button class="btn btn-block btn-secondary" (click)="navigateTo('home')">
      {{ 'common.cancel' | cxTranslate }}
    </button>
  </ng-container>
  <ng-container *cxFeature="'!a11yUseButtonsForBtnLinks'">
    <a
      [routerLink]="{ cxRoute: 'home' } | cxUrl"
      class="btn btn-block btn-secondary"
      cxBtnLikeLink
      >{{ 'common.cancel' | cxTranslate }}</a
    >
  </ng-container>

  <button class="btn btn-block btn-primary" [disabled]="form.disabled">
    {{ 'common.save' | cxTranslate }}
  </button>
</form>

<ng-template #requiredAsterisk>
  <abbr
    *cxFeature="'a11yRequiredAsterisks'"
    aria-hidden="true"
    class="text-decoration-none required-asterisk"
    title="{{ 'common.required' | cxTranslate }}"
    >*</abbr
  >
</ng-template>
